import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Tab, Table, Tabs } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import {
  isAdmin,
  getType,
  toastStyle,
  getTodayDateISO,
} from "../../Helpers/Utils/Common";
import { CSVLink } from "react-csv";
import Select from "react-select";

//components
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import InputError from "../../Components/InputError/InputError";
import Modal from "antd/es/modal/Modal";
import FileExceedModal from "../../Components/Modals/FileExceedModal";
import Compressor from "compressorjs";
import noDataImg from "../../Assets/Images/no-data-img.png";
import upload from "../../Assets/Images/upload.png";
import Upload from "antd/es/upload/Upload";
import trash from "../../Assets/Images/trash.png";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import downloadIcon from "../../Assets/Images/download_icon.png";

//api
import {
  getAllEmployees,
  createEmployee,
  createEmployeePotato,
  getEmployee,
  deleteEmployee,
  searchEmployee,
  updateEmployee,
  // changeEmployeeStatus
} from "../../Helpers/apiCalls/employeesApi";
import { refreshPage } from "../../Helpers/Utils/Common";
import { validateEmployees } from "../../Helpers/Validation/Manage/EmployeesValidation";
import { validateEmployeesEdit } from "../../Helpers/Validation/Manage/EmployeesValidationEdit";
import NoDataImg from "../../Assets/Images/no-data-img.png";
// import ChangeStatusModal from './ChangeStatusModal';
import { numberFormat } from "./../../Helpers/Utils/Common";
import { getDepartment } from "../../Helpers/apiCalls/departmentApi";
import { getAllShifts } from "../../Helpers/apiCalls/Manage/ShiftApi";
import Footer from "../../Components/Footer/Footer";
import * as XLSX from "xlsx";

export default function Employees() {
  const {Dragger} = Upload;
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const today = getTodayDateISO();
  const [file, setFile] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [shifts, setShifts] = useState([]);
  const accountType = getType();
  // 
  // 
  //FILTER
  const [filterType, setFilterType] = useState("");
  const [filteredEmployeeData, setFilteredEmployeeData] = useState([]);

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // // VIEW
  const [showViewEmployeeModal, setShowViewEmployeeModal] = useState(false);
  const handleShowViewEmployeeModal = () => setShowViewEmployeeModal(true);
  const handleCloseViewEmployeeModal = () => setShowViewEmployeeModal(false);

  // EDIT
  const [showEditEmployeeModal, setShowEditEmployeeModal] = useState(false);
  const handleShowEditEmployeeModal = () => setShowEditEmployeeModal(true);
  const handleCloseEditEmployeeModal = () => setShowEditEmployeeModal(false);

  // ADD
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const handleShowAddEmployeeModal = () => setShowAddEmployeeModal(true);
  const handleCloseAddEmployeeModal = () => setShowAddEmployeeModal(false);
  // CHANGE STATUS
  // const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  // const handleShowChangeStatusModal = () => setShowChangeStatusModal(true);
  // const handleCloseChangeStatusModal = () => setShowChangeStatusModal(false);

  //API
  const [employeesData, setEmployeesData] = useState([]);
  const [hasNewlyAddedEmployee, setHasNewlyAddedEmployee] = useState(false);
  const [crewData, setCrewData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [employeeData, setEmployeeData] = useState({});
  const [selectedID, setSelectedID] = useState("");
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState('');
  const [fileList, setFileList] = useState([]);
  const [prevAttachments, setPrevAttachments] = useState([]);
  const [profilePic, setProfilePic] = useState([]);
  const [showFileExceedModal, setShowFileExceedModal] = useState(false);
  const [filterConfig, setFilterConfig] = useState({
    department: "",
    employee_type: "",
    status: "active",
    page: 1,
  });
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Change this based on your requirement

  const handlePageChange = page => {
      setCurrentPage(page);
      setFilterConfig(prev => ({
      ...prev,
      page: page,
      }));
  };
  const [employeeDataUpdate, setEmployeeDataUpdate] = useState({
    username: "",
    password: "",
    last_name: "",
    first_name: "",
    middle_name: "",
    suffix: "",
    email: "",
    type: "",
    contact_no: "",
    address: "",
    gender: "",
    birthdate: "",
    civil_status: "",
    nationality: "",
    religion: "",
    remarks: "",
    payee_id_number: "",
    account_number: "",
    sss: "",
    pagibig: "",
    philhealth: "",
    employment_status: "",
    salary_type: "",
    salary: "",
    daily_allowance: "",
    communication_allowance: "",
    transportation_allowance: "",
    food_allowance: "",
    hmo_allowance: "",
    tech_allowance: "",
    ops_allowance: "",
    special_allowance: "",
    profile_picture: "",
    rent: "",
  });
  const [employeeDetails, setEmployeeDetails] = useState({
    username: "",
    password: "",
    confirm_password: "",
    last_name: "",
    first_name: "",
    middle_name: "",
    suffix: "",
    email: "",
    type: "",
    contact_no: "",
    address: "",
    gender: "",
    birthdate: "",
    civil_status: "",
    nationality: "",
    religion: "",
    remarks: "",
    payee_id_number: "",
    account_number: "",
    sss: "0",
    sss_loan: "0",
    pagibig: "0",
    pagibig_loan: "0",
    philhealth: "0",
    employment_status: "",
    salary_type: "",
    salary: "0",
    salary_per_day: "0",
    hours_per_day: "8",
    salary_per_hour: "0",
    daily_allowance: "0",
    other_allowances: "0",
    transportation_allowance: "0",
    food_allowance: "",
    hmo_allowance: "",
    tech_allowance: "",
    ops_allowance: "",
    special_allowance: "",
    profile_picture: "",
    rent: "0",
  });

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    first_name: false,
    middle_name: false,
    last_name: false,
    email: false,
    username: false,
    password: false,
    confirm_password: false,
    type: false,
    contact_no: false,
    address: false,
    gender: false,
    birthdate: false,
    civil_status: false,
    nationality: false,
    religion: false,
    profile_picture: false,
    employment_status: false,
    salary_type: false,
    salary: false,
  });

  const [isErrorEdit, setIsErrorEdit] = useState({
    first_name: false,
    middle_name: false,
    last_name: false,
    email: false,
    username: false,
    // password: false,
    type: false,
    contact_no: false,
    address: false,
    gender: false,
    birthdate: false,
    civil_status: false,
    nationality: false,
    religion: false,
    profile_picture: false,
    employment_status: false,
    salary_type: false,
    salary: false,
  });

  const excelHeaders = [
    { label: "FULL NAME", key: "full_name" },
    { label: "DEPARTMENT", key: "department" },
    { label: "POSITION", key: "employee_type" },
    { label: "USERNAME", key: "username" },
    { label: "STATUS", key: "status" },
  ];

  const handleAddChange = (e, select) => {
    if(select) {
      setEmployeeDetails((prevState) => ({
        ...prevState,
        [e.name]: e.value,
        [e.select_value]: {
          label: e.label,
          value: e.value,
        },
      }));
    } else {
      const { name, value } = e.target;
      if (name === "salary_type") {
        if (value === "monthly") {
          setEmployeeDetails((prevState) => ({
            ...prevState,
            [name]: value,
            ["salary_per_day"]: 0,
            ["salary"]: 0,
          }));
        } else {
          setEmployeeDetails((prevState) => ({
            ...prevState,
            [name]: value,
            ["salary"]: 0,
          }));
        }
      }
      if (name === "salary_per_day") {
        setEmployeeDetails((prevState) => ({
          ...prevState,
          [name]: value,
          ["salary"]: parseFloat(value) / 8,
        }));
      } else {
        setEmployeeDetails((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };
  

  const handleEdit = (e, select) => {
    if(select) {
      setEmployeeDataUpdate((prevState) => ({
        ...prevState,
        [e.name]: e.value,
        [e.select_value]: {
          label: e.label,
          value: e.value,
        },
      }));
    } else {
      const { name, value } = e.target;
      if (name === "salary_type") {
        if (value === "monthly") {
          setEmployeeDataUpdate((prevState) => ({
            ...prevState,
            [name]: value,
            ["salary_per_day"]: 0,
            ["salary"]: 0,
          }));
        } else {
          setEmployeeDataUpdate((prevState) => ({
            ...prevState,
            [name]: value,
            ["salary"]: 0,
          }));
        }
      }
      if (name === "salary_per_day") {
        setEmployeeDataUpdate((prevState) => ({
          ...prevState,
          [name]: value,
          ["salary"]: parseFloat(value) / 8,
        }));
      } else {
        setEmployeeDataUpdate((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  //onEdit
  function handleOnEdit() {
    handleCloseViewEmployeeModal();
    handleShowEditEmployeeModal();
  }

  //EDIT OR UPDATE EMPLOYEE
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEmployeeDataUpdate((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //DELETE or REMOVE EMPLOYEE
  function handleDeleteEmployee() {
    removeEmployee(selectedID);
  }

  //DROPDOWN
  function handleSelectChange(e, row) {
    // fetchEmployee(row.id);
    setSelectedID(row.pin);
    
    // setEmployeeData(row);
    setEmployeeDataUpdate({ 
      ...row, 
      password: "", 
      shift_id_value: {
        label: row.shift_name,
        value: row.shift_id
      } 
    });
    setPrevAttachments(row.attachments.filter((data) => {
      return data.file_type === "attachment"
    }));
    setProfilePic(row.attachments.filter((data) => {
      return data.file_type === "profile_picture"
    }));
    if (e.target.value === "delete-employee") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-employee") {
      setPrevAttachments(row.attachments);
      handleShowEditEmployeeModal();
    } else if (e.target.value === "view-employee") {
      handleShowViewEmployeeModal();
    } else {
      refreshPage();
    }
  }

  const [searchUsername, setSearchUsername] = useState("");

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }


  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-employee" className="color-options">
          View
        </option>
        {(accountType === "admin" || accountType === "hr_officer") && (
          <option value="edit-employee" className="color-options">
            Edit
          </option>
        )}
        {/* <option value="update-status" className="color-options">
                    Update Status
                </option> */}
        {/* {(accountType === "admin" || accountType === "hr_officer") && (
          <option value="delete-employee" className="color-red">
            Delete
          </option>
        )} */}
      </Form.Select>
    );
  }

  //API CALL
  async function fetchAllEmployees() {
    setTotalItems(0);
    setEmployeesData([]);
    setCrewData([]);
    setStaffData([]);
    setFilteredEmployeeData([]);
    setShowLoader(true);
    const response = await searchEmployee(filterConfig);
    
    if (response.data) {
      var employeesList = response.data.data
        // .filter((data) => {
        //   return data.id !== "9" && data.id !== "21" && data.id !== "73";
        // })
        .sort((a, b) =>
          a.first_name.toUpperCase() > b.first_name.toUpperCase()
            ? 1
            : b.first_name.toUpperCase() > a.first_name.toUpperCase()
            ? -1
            : 0
        );
      employeesList.map((data, key) => {
        if (data.middle_name !== null) {
          employeesList[key].full_name =
            data.first_name + " " + data.middle_name + " " + data.last_name;
          setEmployeeData(employeesList);
        } else {
          employeesList[key].full_name = data.first_name + " " + data.last_name;
          setEmployeeData(employeesList);
        }
      });
      setEmployeesData(employeesList);
      setFilteredEmployeeData(employeesList);
      setTotalItems(response.data.size);
    } else {
      setEmployeesData([]);
      setFilteredEmployeeData([]);
      setTotalItems(response.data.size);
    }
    setShowLoader(false);
  }

  async function handleSaveEmployee() {
    if (isClicked) {
      return;
    }
    if (validateEmployees(employeeDetails, setIsError)) {
      if (employeeDetails.password === employeeDetails.confirm_password) {
        setIsClicked(true);
        employeeDetails.attachments = fileList
        const response = await createEmployee(employeeDetails, file);
        console.log(response)
        if (response.data) {
            toast.success(response.data.message, {
              style: toastStyle(),
            });
            setShowAddEmployeeModal(false);
            setTimeout(() => refreshPage(), 1000);
        } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
          setIsClicked(false);
          setTimeout(() => {
            // refreshPage();
          }, 1000);
        }
      } else {
        toast.error("Password does not match!", {
          style: toastStyle(),
        });
      }
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() });
    }
  }

  async function handleEditEmployee() {
    if (validateEmployeesEdit(employeeDataUpdate, setIsErrorEdit)) {
      setIsClicked(true);
      employeeDataUpdate.attachments = fileList
      employeeDataUpdate.prev_files = prevAttachments
      const response = await updateEmployee(employeeDataUpdate, file);
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        handleCloseEditEmployeeModal();
        setTimeout(() => refreshPage(), 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
        handleCloseEditEmployeeModal();
        setTimeout(() => refreshPage(), 1000);
      }
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() });
    }
  }

  async function removeEmployee(id) {
    setIsClicked(true);
    const response = await deleteEmployee(id);
    if (response.data) {
      const response2 = await deleteEmployee(id);
      if (response2.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        handleCloseDeleteModal();
        refreshPage();
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
        handleCloseDeleteModal();
      }
    } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
    }
  }

  async function fetchDepartment() {
      setShowLoader(true);
      setDepartments([]);
      const response = await getDepartment({});
      if (response.data) {
          setDepartments(response.data.data);
      }
      setShowLoader(false);
  }

  async function fetchShifts() {
      setShowLoader(true);
      setShifts([]);
      const response = await getAllShifts({});
      if (response.data) {
          var data = response.data.data.data.map((shift) => {
            var info = {}
            info.label = shift.name
            info.value = shift.id
            info.name = "shift_id"
            info.select_value = "shift_id_value"
            return info
          })
          setShifts(data);
      }
      setShowLoader(false);
  }

  const handleRemove = (selectedFile) => {
      var newlist = fileList.filter((file) => {
          return selectedFile.uid !== file.uid;
      });
      setFileList(newlist);
  };

  const handleBeforeUpload = (file) => {
      if (file.size > 2000000) {
          setShowFileExceedModal(true);
      } else {
          //COMPRESSING FILE
          new Compressor(file, {
              quality: 0.6,
              success: (compressedResult) => {
                  var file_object = compressedResult
                  file_object.file_type = "attachment"
                  setFileList([...fileList, file_object]);
              },
          });
      }
      return false;
  };


  const handleProfileUpload = (file) => {
      if (file.size > 2000000) {
          setShowFileExceedModal(true);
      } else {
          //COMPRESSING FILE
          new Compressor(file, {
              quality: 0.6,
              success: (compressedResult) => {
                  var file_object = compressedResult
                  file_object.file_type = "profile_picture"
                  setFile([file_object]);
              },
          });
      }
      return false;
  };

  function handleRemoveItemAttachment(url) {
      
      var newList = prevAttachments.filter((data) => {return data.file_url !== url})
      setPrevAttachments(newList);
      setPreview(false)
  }

  useEffect(() => {
    fetchDepartment()
    fetchShifts()
  }, []);

  useEffect(() => {
    fetchAllEmployees();
  }, [filterConfig, currentPage]);


  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll('.numeric-input');
    numericInputs.forEach(function(input) {
      input.addEventListener('wheel', function(e) {
        e.preventDefault();
      });
    });
  }
  limitScroll();

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> EMPLOYEES </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  className="search-bar"
                name="name"
                placeholder="Search name..."
                onKeyPress={(e) =>
                  e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
                }
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
              <button className="add-btn" onClick={handleShowAddEmployeeModal}>
                Add
              </button>
              </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={2} className="mb-2 mb-lg-0">
            <Form.Select
              type="select"
              className="date-filter force-width w-full"
              classNamePrefix="react-select"
              placeholder="Department..."
              name="department"
              value={filterConfig.department}
              onChange={(e) =>
                setFilterConfig((prev) => {
                  return { ...prev, department: e.target.value };
                })
              }
            >
              <option value="">All Department</option>
              {
                departments?.map((data) => {
                  return (
                    <option value={data.name}>{data.name}</option>
                  )
                })
              }
            </Form.Select>
            </Col>
            <Col xs={12} lg={2} className="mb-2 mb-lg-0">
            <Form.Select
              type="select"
              className="date-filter force-width w-full"
              classNamePrefix="react-select"
              placeholder="Employee Type..."
              name="employee_type"
              value={filterConfig.employee_type}
              onChange={(e) =>
                setFilterConfig((prev) => {
                  return { ...prev, employee_type: e.target.value };
                })
              }
            >
              <option value="">All Employee Type</option>
              <option value="purchasing_officer">Purchasing Officer</option>
              <option value="bidding_officer">Bidding Officer</option>
              <option value="warehouse_manager">Warehouse Manager</option>
              <option value="warehouse_assistant">Warehouse Assistant</option>
              <option value="wholesale_head">Wholesale Head</option>
              <option value="wholesale_assistant">Wholesale Assistant</option>
              <option value="account_officer">Account Officer</option>
              <option value="collection_officer">Collection Officer</option>
              <option value="hr_officer">HR Officer</option>
              <option value="branch_oic">Branch OIC</option>
              <option value="branch_inventory_officer">Branch Inventory Officer</option>
              <option value="cashier">Cashier</option>
            </Form.Select>
            </Col>
            <Col xs={12} lg={2} className="mb-2 mb-lg-0">
            <Form.Select
              type="select"
              className="date-filter force-width w-full"
              classNamePrefix="react-select"
              placeholder="Employee Type..."
              name="status"
              value={filterConfig.status}
              onChange={(e) =>
                setFilterConfig((prev) => {
                  return { ...prev, status: e.target.value };
                })
              }
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
            </Col>
          </Row>
          <div className="mb-2" />
          <ManageTableWithDynamicPagination
            tableHeaders={[
              "FULL NAME",
              "DEPARTMENT/BRANCH",
              "POSITION",
              "USERNAME",
              "CONTACT NO.",
              "EMAIL",
              "STATUS",
              "ACTIONS",
            ]}
            headerSelector={[
              "full_name",
              "department",
              "employee_type",
              "username",
              "contact_no",
              "email",
              "status",
            ]}
            tableData={filteredEmployeeData}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}            
          />
        </div>
        <div className="mb-4" />
        <div className="mb-3" />
        <Row>
            <Col lg={9} className="mt-3 mt-lg-0"></Col>
            <Col lg={3} className="mt-3 mt-lg-0">
              <div className="PO-filters">
              <CSVLink
                className="primary-btn download-csv px-3 py-2"
                data={filteredEmployeeData}
                headers={excelHeaders}
                target="_blank"
                filename={`${getTodayDateISO()} Employees`}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon}></img>
                </span>
                Download Excel
              </CSVLink>
              </div>
            </Col>  
        </Row>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="employee"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteEmployee}
        isClicked={isClicked}
      />

      {/* <ChangeStatusModal
                show={showChangeStatusModal}
                hide={handleCloseChangeStatusModal}
                type="change employee status"
                handler={handleChangeStatus}
                isClicked={isClicked}
            /> */}

      <AddModal
        title="EMPLOYEE"
        type="employee"
        show={showAddEmployeeModal}
        onHide={handleCloseAddEmployeeModal}
        onSave={handleSaveEmployee}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              PERSONAL INFORMATION
            </span>
            <Col xs={12} lg={3}>
              FIRST NAME
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="first_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.first_name}
                message={"First name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              LAST NAME
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="last_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.last_name}
                message={"Last name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              MIDDLE NAME
              <Form.Control
                type="text"
                name="middle_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              SUFFIX
              <Form.Control
                type="text"
                name="suffix"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6} >
              DEPARTMENT TYPE
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="department"
                defaultValue={employeeData.department}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                {
                  departments?.map((data) => {
                    return (
                      <option value={data.name}>{data.name}</option>
                    )
                  })
                }
              </select>
              <InputError isValid={isError.type} message={"type is required"} />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              POSITION
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="employee_type"
                defaultValue={employeeData.employee_type}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="purchasing_officer">Purchasing Officer</option>
                <option value="bidding_officer">Bidding Officer</option>
                <option value="warehouse_manager">Warehouse Manager</option>
                <option value="warehouse_assistant">Warehouse Assistant</option>
                <option value="wholesale_head">Wholesale Head</option>
                <option value="wholesale_assistant">Wholesale Assistant</option>
                <option value="account_officer">Account Officer</option>
                <option value="collection_officer">Collection Officer</option>
                <option value="hr_officer">HR Officer</option>
                <option value="branch_oic">Branch OIC</option>
                <option value="branch_inventory_officer">Branch Inventory Officer</option>
                <option value="cashier">Cashier</option>
              </select>
              <InputError isValid={isError.type} message={"type is required"} />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              USERNAME
              {employeeDetails.type !== "office" && (
                <label className="badge-required">{` *`}</label>
              )}
              <Form.Control
                type="text"
                name="username"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.username}
                message={"Username is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PASSWORD
              {employeeDetails.type !== "office" && (
                <label className="badge-required">{` *`}</label>
              )}
              <Form.Control
                type="password"
                name="password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.password}
                message={"Password is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONFIRM PASSWORD
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="password"
                name="confirm_password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Confirm Password is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONTACT NUMBER
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="contact_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.contact_no}
                message={"Contact number is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ADDRESS
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="address"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.address}
                message={"Address is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              EMAIL
              <label className="badge-required"></label>
              <Form.Control
                type="email"
                name="email"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                // required
              />
              <InputError
                isValid={isError.email}
                message={"Email is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              GENDER
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="gender"
                defaultValue={employeeData.gender}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <InputError
                isValid={isError.gender}
                message={"Gender is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              BIRTHDATE
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="date"
                name="birthdate"
                className="nc-modal-custom-text"
                // defaultValue={today}
                onChange={(e) => handleAddChange(e)}
              />
              <InputError
                isValid={isError.birthdate}
                message={"Birthdate is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CIVIL STATUS
              {/* <label className="badge-required">{` *`}</label> */}
              <select
                className="nc-modal-custom-select"
                name="civil_status"
                defaultValue={employeeData.civil_status}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="widowed">Widowed</option>
              </select>
              <InputError
                isValid={isError.civil_status}
                message={"Civil status is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              NATIONALITY
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="nationality"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                // required
              />
              <InputError
                isValid={isError.nationality}
                message={"Nationality is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RELIGION
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="religion"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                // required
              />
              <InputError
                isValid={isError.religion}
                message={"religion is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              REMARKS
              <Form.Control
                type="text"
                name="remarks"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              EDUCATIONAL ATTAINMENT
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="educational_attainment"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                // required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              MEDICAL CONDITION
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="medical_condition"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                // required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PROFILE PICTURE
              <input
                class="form-control date-filter gotham"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFileSm"
                onChange={(e) => handleProfileUpload(e.target.files[0])}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-2">
              EMERGENCY CONTACT
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              NAME
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="emergency_contact_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONTACT NO.
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="emergency_contact_no"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RELATIONSHIP
              <Form.Control
                type="text"
                name="emergency_contact_relation"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>

          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              ATM ACCOUNT DETAILS
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAYEE ID
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="payee_id_number"
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.salary}
                message={"payee ID is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              Account Number
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="account_number"
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.salary}
                message={"account number is required"}
              />
            </Col>
          </Row>
          {/* <hr/>
                    <Row className="nc-modal-custom-row mt-0">
                        <span className="custom-modal-body-title-employee mb-2">
                            LOAN INFORMATION
                        </span>
                        <Col xs={6}>
                            SSS LOAN
                            <Form.Control
                                type="number"
                                name="sss_loan"
                                className="nc-modal-custom-input"
                                value={employeeDetails.sss_loan}
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-4">
                        <Col xs={6}>
                            PAG-IBIG LOAN
                            <Form.Control
                                type="number"
                                name="pagibig_loan"
                                className="nc-modal-custom-input"
                                value={employeeDetails.pagibig_loan}
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row> */}
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              EMPLOYMENT INFORMATION
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              EMPLOYMENT STATUS
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="employment_status"
                defaultValue={employeeData.employment_status}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="full-time">Full-Time</option>
                <option value="part-time">Part-Time</option>
                <option value="intern">Trainee</option>
              </select>
              <InputError
                isValid={isError.employment_status}
                message={"Employment status is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SALARY TYPE
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="salary_type"
                defaultValue={employeeData.salary_type}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="hourly">Hourly</option>
                <option value="monthly">Monthly</option>
              </select>
              <InputError
                isValid={isError.salary_type}
                message={"Salary type is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PAYROLL CYCLE
              {/* <label className="badge-required">{` *`}</label> */}
              <select
                className="nc-modal-custom-select"
                name="payroll_cycle"
                defaultValue={employeeData.payroll_cycle}
                onChange={(e) => handleAddChange(e)}
              >
                <option value={""}>Select</option>
                <option value="weekly">weekly</option>
                <option value="bi-monthly">bi-monthly</option>
                <option value="monthly">monthly</option>
              </select>
              {/* <InputError
                                isValid={isError.salary_type}
                                message={"Salary type is required"}
                            /> */}
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SALARY
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="number"
                name="salary"
                className="nc-modal-custom-input"
                value={employeeDetails.salary}
                onChange={(e) => handleAddChange(e)}
                disabled={
                  employeeDetails.salary_type === "hourly" ? true : false
                }
              />
              <InputError
                isValid={isError.salary}
                message={"Salary is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RATE PER DAY
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="salary_per_day"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={numberFormat(employeeDetails.salary_per_day)}
                onChange={(e) => handleAddChange(e)}
                disabled={
                  employeeDetails.salary_type === "monthly" ? true : false
                }
              />
              <InputError
                isValid={isError.salary}
                message={"Salary is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              HOURS PER DAY
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="hours_per_day"
                className="nc-modal-custom-input"
                value={employeeDetails.hours_per_day}
                onChange={(e) => handleAddChange(e)}
                disabled
              />
              <InputError
                isValid={isError.shift}
                message={"shift is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SHIFT
              <Select
                className="react-select-container mb-4"
                classNamePrefix="react-select"
                placeholder="Select Shift..."
                options={shifts}
                onChange={(e) => handleAddChange(e, true)}
              />
              <InputError
                isValid={isError.salary}
                message={"Salary is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-2">
              LOAN DETAILS
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              SSS REF NO.
              <Form.Control
                type="number"
                name="sss_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.sss_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              SSS DATE STARTED
              <Form.Control
                type="date"
                name="sss_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.sss_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TIN REF NO.
              <Form.Control
                type="number"
                name="tin_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.tin_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TIN DATE STARTED
              <Form.Control
                type="date"
                name="tin_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.tin_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PHILHEALTH REF NO.
              <Form.Control
                type="number"
                name="philhealth_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.philhealth_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PHILHEALTH DATE STARTED
              <Form.Control
                type="date"
                name="philhealth_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.philhealth_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAG-IBIG REF NO.
              <Form.Control
                type="number"
                name="pagibig_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.pagibig_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAG-IBIG DATE STARTED
              <Form.Control
                type="date"
                name="pagibig_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.pagibig_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              CEDULA REF NO.
              <Form.Control
                type="number"
                name="cedula_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.cedula_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              CEDULA DATE STARTED
              <Form.Control
                type="date"
                name="cedula_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.cedula_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              BENEFIT CONTRIBUTION INFORMATION (Amount Per Payroll Cycle)
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SSS AMOUNT
              <Form.Control
                type="number"
                name="sss"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.sss}
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PAG-IBIG AMOUNT
              <Form.Control
                type="number"
                name="pagibig"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.pagibig}
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PHILHEALTH AMOUNT
              <Form.Control
                type="number"
                name="philhealth"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.philhealth}
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              ALLOWANCE
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRANSPORTATION ALLOWANCE
              <Form.Control
                type="number"
                name="transportation_allowance"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.transportation_allowance}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              OTHER ALLOWANCES
              <Form.Control
                type="number"
                name="other_allowances"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDetails.other_allowances}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col>
                <Dragger
                    fileList={fileList}
                    onRemove={handleRemove}
                    beforeUpload={handleBeforeUpload}
                    multiple={false}
                    listType="picture"
                    progress={{ showInfo: true }}
                >
                    <img src={upload} className="cursor-pointer" />
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                </Dragger>
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="EMPLOYEE"
        type="employee"
        show={showEditEmployeeModal}
        onHide={handleCloseEditEmployeeModal}
        onSave={handleEditEmployee}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              FIRST NAME
              <Form.Control
                type="text"
                name="first_name"
                defaultValue={employeeDataUpdate.first_name}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
              <InputError
                isValid={isErrorEdit.first_name}
                message={"First name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              LAST NAME
              <Form.Control
                type="text"
                name="last_name"
                defaultValue={employeeDataUpdate.last_name}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
              <InputError
                isValid={isErrorEdit.last_name}
                message={"Last name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              MIDDLE NAME
              <Form.Control
                type="text"
                name="middle_name"
                defaultValue={employeeDataUpdate.middle_name}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
              <InputError
                isValid={isErrorEdit.middle_name}
                message={"Middle name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              SUFFIX
              <Form.Control
                type="text"
                name="suffix"
                defaultValue={employeeDataUpdate.suffix}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              STATUS
              <select
                className="nc-modal-custom-select"
                name="status"
                defaultValue={employeeDataUpdate.status}
                onChange={(e) => handleEdit(e)}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              DEPARTMENT TYPE
              <select
                className="nc-modal-custom-select"
                name="department"
                defaultValue={employeeDataUpdate.department}
                onChange={(e) => handleEdit(e)}
              >
                <option value={""}>Select</option>
                {
                  departments?.map((data) => {
                    return (
                      <option value={data.name}>{data.name}</option>
                    )
                  })
                }
              </select>
              <InputError
                isValid={isErrorEdit.type}
                message={"type is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              POSITION
              <select
                className="nc-modal-custom-select"
                name="employee_type"
                defaultValue={employeeDataUpdate.employee_type}
                onChange={(e) => handleEdit(e)}
              >
                <option value="purchasing_officer">Purchasing Officer</option>
                <option value="bidding_officer">Bidding Officer</option>
                <option value="warehouse_manager">Warehouse Manager</option>
                <option value="warehouse_assistant">Warehouse Assistant</option>
                <option value="wholesale_head">Wholesale Head</option>
                <option value="wholesale_assistant">Wholesale Assistant</option>
                <option value="account_officer">Account Officer</option>
                <option value="collection_officer">Collection Officer</option>
                <option value="hr_officer">HR Officer</option>
                <option value="branch_oic">Branch OIC</option>
                <option value="branch_inventory_officer">Branch Inventory Officer</option>
                <option value="cashier">Cashier</option>
              </select>
              <InputError
                isValid={isErrorEdit.type}
                message={"type is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              USERNAME
              {employeeDataUpdate.type !== "office" && (
                <label className="badge-required">{` *`}</label>
              )}
              <Form.Control
                type="text"
                name="username"
                defaultValue={employeeDataUpdate.username}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
              <InputError
                isValid={isErrorEdit.username}
                message={"Username is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              RESET PASSWORD
              <Form.Control
                type="text"
                name="password"
                defaultValue={employeeDataUpdate.password}
                // name="password_reset"
                // defaultValue={employeeDataUpdate.password_reset}
                className="nc-modal-custom-input-edit"
                required
                onChange={(e) => handleEdit(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONTACT NUMBER
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="number"
                name="contact_no"
                defaultValue={employeeDataUpdate.contact_no}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleEdit(e)}
                required
              />
              <InputError
                isValid={isErrorEdit.contact_no}
                message={"Contact number is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ADDRESS
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="address"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.address}
                onChange={(e) => handleEdit(e)}
                required
              />
              <InputError
                isValid={isErrorEdit.address}
                message={"Address is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              EMAIL
              <label className="badge-required"></label>
              <Form.Control
                type="email"
                name="email"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.email}
                onChange={(e) => handleEdit(e)}
                // required
              />
              <InputError
                isValid={isErrorEdit.email}
                message={"Email is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              GENDER
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="gender"
                defaultValue={employeeDataUpdate.gender}
                onChange={(e) => handleEdit(e)}
              >
                <option value={""}>Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <InputError
                isValid={isErrorEdit.gender}
                message={"Gender is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              BIRTHDATE
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="date"
                name="birthdate"
                className="nc-modal-custom-text"
                defaultValue={employeeDataUpdate.birthdate}
                onChange={(e) => handleEdit(e)}
              />
              <InputError
                isValid={isErrorEdit.birthdate}
                message={"Birthdate is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CIVIL STATUS
              {/* <label className="badge-required">{` *`}</label> */}
              <select
                className="nc-modal-custom-select"
                name="civil_status"
                defaultValue={employeeDataUpdate.civil_status}
                onChange={(e) => handleEdit(e)}
              >
                <option value={""}>Select</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="widowed">Widowed</option>
              </select>
              <InputError
                isValid={isErrorEdit.civil_status}
                message={"Civil status is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              NATIONALITY
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="nationality"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.nationality}
                onChange={(e) => handleEdit(e)}
                // required
              />
              <InputError
                isValid={isErrorEdit.nationality}
                message={"Nationality is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RELIGION
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="religion"
                defaultValue={employeeDataUpdate.religion}
                className="nc-modal-custom-input"
                onChange={(e) => handleEdit(e)}
                // required
              />
              <InputError
                isValid={isErrorEdit.religion}
                message={"religion is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              REMARKS
              <Form.Control
                type="text"
                name="remarks"
                defaultValue={employeeDataUpdate.remarks}
                className="nc-modal-custom-input"
                onChange={(e) => handleEdit(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              EDUCATIONAL ATTAINMENT
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="educational_attainment"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.educational_attainment}
                onChange={(e) => handleEdit(e)}
                // required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              MEDICAL CONDITION
              <label className="badge-required"></label>
              <Form.Control
                type="text"
                name="medical_condition"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.medical_condition}
                onChange={(e) => handleEdit(e)}
                // required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PROFILE PICTURE
              <input
                class="form-control date-filter gotham"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFileSm"
                onChange={(e) => handleProfileUpload(e.target.files[0])}
              />
            </Col>
          </Row>

          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-2">
              EMERGENCY CONTACT
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              NAME
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="emergency_contact_name"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.emergency_contact_name}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONTACT NO.
              {/* <label className="badge-required">{` *`}</label> */}
              <Form.Control
                type="text"
                name="emergency_contact_no"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.emergency_contact_no}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RELATIONSHIP
              <Form.Control
                type="text"
                name="emergency_contact_relation"
                className="nc-modal-custom-input"
                defaultValue={employeeDataUpdate.emergency_contact_relation}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              ATM ACCOUNT DETAILS
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAYEE ID
              <Form.Control
                type="number"
                name="payee_id_number"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.payee_id_number}
                onChange={(e) => handleEdit(e)}
                disabled={(employeeDataUpdate.payee_id_number !== null 
                    && employeeDataUpdate.payee_id_number !== "null" 
                    && employeeDataUpdate.payee_id_number !== "undefined") && accountType === "hr_officer" ? true : false}
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              Account Number
              <Form.Control
                type="number"
                name="account_number"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.account_number}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              EMPLOYMENT INFORMATION
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              EMPLOYMENT STATUS
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="employment_status"
                defaultValue={employeeDataUpdate.employment_status}
                onChange={(e) => handleEdit(e)}
              >
                <option value={""}>Select</option>
                <option value="full-time">Full-Time</option>
                <option value="part-time">Part-Time</option>
                <option value="intern">Trainee</option>
              </select>
              <InputError
                isValid={isErrorEdit.employment_status}
                message={"Employment status is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SALARY TYPE
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="salary_type"
                defaultValue={employeeDataUpdate.salary_type}
                onChange={(e) => handleEdit(e)}
                disabled={accountType === "admin" ? false : true}
              >
                <option value={""}>Select</option>
                <option value="hourly">Hourly</option>
                <option value="monthly">Monthly</option>
              </select>
              <InputError
                isValid={isErrorEdit.salary_type}
                message={"Salary type is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PAYROLL CYCLE
              {/* <label className="badge-required">{` *`}</label> */}
              <select
                className="nc-modal-custom-select"
                name="payroll_cycle"
                defaultValue={employeeDataUpdate.payroll_cycle}
                onChange={(e) => handleEdit(e)}
              >
                <option value={""}>Select</option>
                <option value="weekly">weekly</option>
                <option value="bi monthly">bi-monthly</option>
                <option value="monthly">monthly</option>
              </select>
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SALARY
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="number"
                name="salary"
                className="nc-modal-custom-input"
                value={employeeDataUpdate.salary}
                onChange={(e) => handleEdit(e)}
                disabled={accountType === "admin" ? employeeDataUpdate.salary_type === "hourly" ? true : false : true}
              />
              <InputError
                isValid={isErrorEdit.salary}
                message={"Salary is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RATE PER DAY
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="number"
                name="salary_per_day"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={numberFormat(employeeDataUpdate.salary_per_day)}
                onChange={(e) => handleEdit(e)}
                disabled={accountType === "admin" ? employeeDataUpdate.salary_type === "monthly" ? true : false : true}
              />
              <InputError
                isValid={isError.salary}
                message={"Salary is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              HOURS PER DAY
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="number"
                name="hours_per_day"
                className="nc-modal-custom-input"
                defaultValue={8}
                onChange={(e) => handleEdit(e)}
                disabled
              />
              <InputError
                isValid={isError.salary}
                message={"Salary is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SHIFT
              <Select
                className="react-select-container mb-4"
                classNamePrefix="react-select"
                placeholder="Select Shift..."
                options={shifts}
                value={employeeDataUpdate.shift_id_value}
                onChange={(e) => handleEdit(e, true)}
              />
              <InputError
                isValid={isError.shift_id}
                message={"shift_id is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-2">
              LOAN DETAILS
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              SSS REF NO.
              <Form.Control
                type="number"
                name="sss_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.sss_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              SSS DATE STARTED
              <Form.Control
                type="date"
                name="sss_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.sss_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TIN REF NO.
              <Form.Control
                type="number"
                name="tin_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.tin_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TIN DATE STARTED
              <Form.Control
                type="date"
                name="tin_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.tin_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PHILHEALTH REF NO.
              <Form.Control
                type="number"
                name="philhealth_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.philhealth_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PHILHEALTH DATE STARTED
              <Form.Control
                type="date"
                name="philhealth_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.philhealth_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAG-IBIG REF NO.
              <Form.Control
                type="number"
                name="pagibig_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.pagibig_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              PAG-IBIG DATE STARTED
              <Form.Control
                type="date"
                name="pagibig_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.pagibig_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              CEDULA REF NO.
              <Form.Control
                type="number"
                name="cedula_ref_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.cedula_ref_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              CEDULA DATE STARTED
              <Form.Control
                type="date"
                name="cedula_started_date"
                className="nc-modal-custom-input hide-spinner numeric-input"
                value={employeeDataUpdate.cedula_started_date}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              BENEFIT CONTRIBUTION INFORMATION (Amount Per Payroll Cycle)
            </span>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SSS AMOUNT
              <Form.Control
                type="number"
                name="sss"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.sss}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PAG-IBIG AMOUNT
              <Form.Control
                type="number"
                name="pagibig"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.pagibig}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PHILHEALTH AMOUNT
              <Form.Control
                type="number"
                name="philhealth"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.philhealth}
                onChange={(e) => handleEdit(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-2">
              ALLOWANCE
            </span>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRANSPORTATION ALLOWANCE
              <Form.Control
                type="number"
                name="transportation_allowance"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.transportation_allowance}
                onChange={(e) => handleEdit(e)}
                disabled={accountType === "admin" ? false : true}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              OTHER ALLOWANCES
              <Form.Control
                type="number"
                name="other_allowances"
                className="nc-modal-custom-input hide-spinner numeric-input"
                defaultValue={employeeDataUpdate.other_allowance}
                onChange={(e) => handleEdit(e)}
                disabled={accountType === "admin" ? false : true}
              />
            </Col>
          </Row>
          <div className="mt-4 noPrint mx-3">
              <Row className="review-data mb-2">
                  FILE ATTACHMENTS
              </Row>
              <Row className="">
                  {
                      prevAttachments && prevAttachments.map((attachment) => (
                          <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                              <img src={attachment.file_url}  className="img-preview"/>
                          </Col>
                      ))
                  }
                  {
                      !prevAttachments || prevAttachments.length === 0 && 
                      <Col xs={1}>
                      <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img src={noDataImg} alt="no data found" className="img-preview"/>
                      </div>
                      </Col>
                  }
              </Row>
          </div>
          <Row className="mt-4 mb-2">
            <Col>
                <Dragger
                    fileList={fileList}
                    onRemove={handleRemove}
                    beforeUpload={handleBeforeUpload}
                    multiple={false}
                    listType="picture"
                    progress={{ showInfo: true }}
                >
                    <img src={upload} className="cursor-pointer" />
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                </Dragger>
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewEmployeeModal}
        onHide={handleCloseViewEmployeeModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              EMPLOYEE DETAILS
            </span>
            <div className="mt-3 mb-3 container-wrapper">
              <div className="mt-4 noPrint mx-3 justify-content-center">
                <Row className="justify-content-center">
                    {
                        profilePic && profilePic.map((attachment) => (
                            // <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                <img 
                                  src={attachment.file_url}  
                                  className="profile-preview"
                                  onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}}
                                />
                            // </Col>
                        ))
                    }
                    {
                        !profilePic || profilePic.length === 0 && 
                        <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                            <img src={noDataImg} alt="no data found" className="img-preview"/>
                        </div>
                        </Col>
                    }
                </Row>
              </div>
              {/* <Row className="nc-modal-custom-row-view">
                <Col>
                  {employeeDataUpdate.profile_picture !== "" ||
                  employeeDataUpdate.profile_picture !== null ? (
                    <>
                      <div className="row justify-content-center mb-4">
                        <div
                          className="col-sm-12 align-center"
                          style={{ textAlignLast: "center" }}
                        >
                          <img
                            src={employeeDataUpdate.profile_picture}
                            width={150}
                            height={150}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="no-data-cont mb-4">
                        <div
                          className="mt-5 mb-2"
                          style={{ textAlignLast: "center" }}
                          alt="no data found"
                        >
                          <img src={NoDataImg} width={150} height={150} />
                        </div>
                        <span>Uh Oh! No Image found.</span>
                      </div>
                    </>
                  )}
                </Col>
              </Row> */}
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee mb-3">
                  PERSONAL INFORMATION
                </span>
                <Col xs={4}>
                  FULL NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {employeeDataUpdate.full_name} </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  USERNAME
                  <Row className="nc-modal-custom-row">
                    <Col> {employeeDataUpdate.username} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col xs={4}>
                  DEPARTMENT TYPE
                  <Row className="nc-modal-custom-row">
                    <Col> {employeeDataUpdate.department} </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  POSITION
                  <Row className="nc-modal-custom-row">
                    <Col> {employeeDataUpdate.employee_type} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  CONTACT NUMBER
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.contact_no
                        ? employeeDataUpdate.contact_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  ADDRESS
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.address
                        ? employeeDataUpdate.address
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  EMAIL
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.email
                        ? employeeDataUpdate.email
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  GENDER
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.gender
                        ? employeeDataUpdate.gender
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  BIRTHDATE
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.birthdate
                        ? employeeDataUpdate.birthdate
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  CIVIL STATUS
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.civil_status
                        ? employeeDataUpdate.civil_status
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  NATIONALITY
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.nationality
                        ? employeeDataUpdate.nationality
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  RELIGION
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.religion
                        ? employeeDataUpdate.religion
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  REMARKS
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.remarks !== "null"
                        ? employeeDataUpdate.remarks
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col xs={4}>
                  EDUCATIONAL ATTAINMENT
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.educational_attainment
                        ? employeeDataUpdate.educational_attainment
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  MEDICAL CONDITION
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.medical_condition
                        ? employeeDataUpdate.medical_condition
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row-view mt-3">
                <span className="custom-modal-body-title-employee mb-2">
                  EMERGENCY CONTACT
                </span>
                <Col>
                  NAME
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.emergency_contact_name
                        ? employeeDataUpdate.emergency_contact_name
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  CONTACT NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.emergency_contact_no
                        ? employeeDataUpdate.emergency_contact_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  RELATIONSHIP
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.emergency_contact_relation
                        ? employeeDataUpdate.emergency_contact_relation
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee">
                  ATM ACCOUNT DETAILS
                </span>
                <Col xs={4}>
                  PAYEE ID
                  <Row className="nc-modal-custom-row">
                    <Col xs={4}>
                      {" "}
                      {employeeDataUpdate.payee_id_number !== "undefined"
                        ? employeeDataUpdate.payee_id_number
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  ACCOUNT NUMBER
                  <Row className="nc-modal-custom-row">
                    <Col xs={4}>
                      {" "}
                      {employeeDataUpdate.account_number !== "undefined"
                        ? employeeDataUpdate.account_number
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee">
                  EMPLOYMENT INFORMATION
                </span>
                <Col>
                  EMPLOYMENT STATUS
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.employment_status
                        ? employeeDataUpdate.employment_status
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  SALARY TYPE
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.salary_type
                        ? employeeDataUpdate.salary_type
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  PAYROLL CYCLE
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.payroll_cycle
                        ? employeeDataUpdate.payroll_cycle
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  SALARY
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.salary
                        ? numberFormat(employeeDataUpdate.salary)
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  RATE PER DAY
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.salary_per_day
                        ? numberFormat(employeeDataUpdate.salary_per_day)
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  HOURS PER DAY
                  <Row className="nc-modal-custom-row">
                    <Col> {"8"} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-2">
                <Col>
                  SHIFT
                  <Row className="nc-modal-custom-row">
                    <Col> {employeeDataUpdate.shift
                        ? employeeDataUpdate.shift
                        : "N/A"}{" "} </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee">
                  LOAN DETAILS
                </span>
                <Col>
                  SSS REF NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.sss_ref_no
                        ? employeeDataUpdate.sss_ref_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  SSS DATE STARTED
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.sss_started_date
                        ? employeeDataUpdate.sss_started_date
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  TIN REF NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.tin_ref_no
                        ? employeeDataUpdate.tin_ref_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  TIN DATE STARTED
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.tin_started_date
                        ? employeeDataUpdate.tin_started_date
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  PHILHEALTH REF NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.philhealth_ref_no
                        ? employeeDataUpdate.philhealth_ref_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  PHILHEALTH DATE STARTED
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.philhealth_started_date
                        ? employeeDataUpdate.philhealth_started_date
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  PAG-IBIG REF NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.pagibig_ref_no
                        ? employeeDataUpdate.pagibig_ref_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  PAG-IBIG DATE STARTED
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.pagibig_started_date
                        ? employeeDataUpdate.pagibig_started_date
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view">
                <Col>
                  CEDULA REF NO.
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.cedula_ref_no
                        ? employeeDataUpdate.cedula_ref_no
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  CEDULA DATE STARTED
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.cedula_started_date
                        ? employeeDataUpdate.cedula_started_date
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr/>
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee">
                  BENEFIT CONTRIBUTION INFORMATION (Amount Per Payroll Cycle)
                </span>
                <Col>
                  SSS AMOUNT
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.sss
                        ? employeeDataUpdate.sss
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  PAG-IBIG AMOUNT
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.pagibig
                        ? employeeDataUpdate.pagibig
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col>
                  PHILHEALTH AMOUNT
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {employeeDataUpdate.philhealth
                        ? employeeDataUpdate.philhealth
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row-view">
                <span className="custom-modal-body-title-employee">
                  ALLOWANCE
                </span>
                <Col xs={4}>
                  TRANSPORTATION ALLOWANCE
                  <Row className="nc-modal-custom-row">
                    <Col xs={4}>
                      {" "}
                      {employeeDataUpdate.transportation_allowance
                        ? employeeDataUpdate.transportation_allowance
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}>
                  OTHER ALLOWANCES
                  <Row className="nc-modal-custom-row">
                    <Col xs={4}>
                      {" "}
                      {employeeDataUpdate.other_allowances
                        ? employeeDataUpdate.other_allowances
                        : "N/A"}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="mt-4 noPrint mx-3">
                  <Row className="review-data mb-2">
                      FILE ATTACHMENTS
                  </Row>
                  <Row className="">
                      {
                          prevAttachments && prevAttachments.map((attachment) => (
                              <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                  <img src={attachment.file_url}  className="img-preview"/>
                              </Col>
                          ))
                      }
                      {
                          !prevAttachments || prevAttachments.length === 0 && 
                          <Col xs={1}>
                          <div className="no-data-cont d-flex justify-content-left preview-container">
                              <img src={noDataImg} alt="no data found" className="img-preview"/>
                          </div>
                          </Col>
                      }
                  </Row>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </ViewModal>
      <Modal zIndex={1100} open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
          <Row className="justify-content-center">
              <img
                  alt="example"
                  style={{
                  width: '100%',
                  }}
                  src={previewFile}
              />
              <div className="mt-2 d-flex justify-content-center">
                  <img
                      src={trash}
                      alt="trash"
                      onClick={() => handleRemoveItemAttachment(previewFile)}
                      className="cursor-pointer"
                  />
              </div>
          </Row>
      </Modal>
      <FileExceedModal
          show={showFileExceedModal}
          onHide={() => setShowFileExceedModal(false)}
          size="2MB"
      />
      <Footer/>
    </div>
  );
}
